export default "__VITE_ASSET__Dc5awI2z__"